<template>
  <div class="sicm_navbar">
    <breadcrumb v-show="!back" class="breadcrumb-container" />
    <back v-show="back" />
    <!-- <div class="breadcrumb-title">
      {{ title_other + (breadcrumbTitle || '首页')}}
      <slot name="tip" class="tip"></slot>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";

/* import { generateTitle } from "@/utils/i18n";*/
import Breadcrumb from "@/components/common/Breadcrumb";
import Back from "@/components/common/Back";

export default {
  components: {
    Breadcrumb,
    Back
  },
  props: {
    back: {
      type: Boolean,
      default: false
    },
    title_other: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["sidebar"]),
    breadcrumbTitle() {
      if (this.$route.query && this.$route.query.title) {
        return this.$route.query.title;
      } else {
        return this.generateTitle(this.$route.meta.title);
      }
    }
  },
  methods: {

    /* generateTitle,*/
    generateTitle(title, vueComponent = null) {
      let that;
      if (vueComponent) {
        that = vueComponent;
      } else {
        that = this;
      }
      const hasKey = that.$te(`route.${title}`);

      if (hasKey) {
        // $t :this method from vue-i18n, inject in @/assets/lang/index.js
        const translatedTitle = that.$t(`route.${title}`);

        return translatedTitle;
      }
      return title;
    }
  }
};
</script>

<style lang="scss" scoped>
.sicm_navbar {
  display: flex;
  align-items: center;
  height: 40px;
  font-size: 14px;
  overflow: hidden;
  position: relative;
  background: #fff;
  z-index: 1;
  border-bottom: 1px solid #d8dce5;
  box-shadow: 0 2px 4px 0 rgba(33, 37, 46, 0.1);
  top: 0;
  padding: 0 24px 0 24px;

  .breadcrumb-title {
    font-size: 20px;
    line-height: 34px;
    span {
      margin-left: 20px;
      font-size: 14px;
      color: #21252e;
    }
  }
}
</style>
